// extracted by mini-css-extract-plugin
module.exports = {"emailSettings":"styles_emailSettings__1TeuD"};